// Static list of planet image names from names.txt
// Split into regular planets and variant planets
export const regularPlanetNames = [
  'dschjungelplanet01.jpg',
  'dschjungelplanet02.jpg',
  'dschjungelplanet03.jpg',
  'dschjungelplanet04.jpg',
  'dschjungelplanet05.jpg',
  'dschjungelplanet06.jpg',
  'dschjungelplanet07.jpg',
  'dschjungelplanet08.jpg',
  'dschjungelplanet09.jpg',
  'dschjungelplanet10.jpg',
  'eisplanet01.jpg',
  'eisplanet02.jpg',
  'eisplanet03.jpg',
  'eisplanet04.jpg',
  'eisplanet05.jpg',
  'eisplanet06.jpg',
  'eisplanet07.jpg',
  'eisplanet08.jpg',
  'eisplanet09.jpg',
  'eisplanet10.jpg',
  'gasplanet01.jpg',
  'gasplanet02.jpg',
  'gasplanet03.jpg',
  'gasplanet04.jpg',
  'gasplanet05.jpg',
  'gasplanet06.jpg',
  'gasplanet07.jpg',
  'gasplanet08.jpg',
  'normaltempplanet01.jpg',
  'normaltempplanet02.jpg',
  'normaltempplanet03.jpg',
  'normaltempplanet04.jpg',
  'normaltempplanet05.jpg',
  'normaltempplanet06.jpg',
  'normaltempplanet07.jpg',
  'trockenplanet01.jpg',
  'trockenplanet02.jpg',
  'trockenplanet03.jpg',
  'trockenplanet04.jpg',
  'trockenplanet05.jpg',
  'trockenplanet06.jpg',
  'trockenplanet07.jpg',
  'trockenplanet08.jpg',
  'trockenplanet09.jpg',
  'trockenplanet10.jpg',
  'wasserplanet01.jpg',
  'wasserplanet02.jpg',
  'wasserplanet03.jpg',
  'wasserplanet04.jpg',
  'wasserplanet05.jpg',
  'wasserplanet06.jpg',
  'wasserplanet07.jpg',
  'wasserplanet08.jpg',
  'wasserplanet09.jpg',
  'wuestenplanet01.jpg',
  'wuestenplanet02.jpg',
  'wuestenplanet03.jpg',
  'wuestenplanet04.jpg',
];

export const variantPlanetNames = [
  'varianten/v1_magic/dschjungelplanet01_v1_magic.webp',
  'varianten/v1_magic/dschjungelplanet02_v1_magic.webp',
  'varianten/v1_magic/dschjungelplanet03_v1_magic.webp',
  'varianten/v1_magic/dschjungelplanet04_v1_magic.webp',
  'varianten/v1_magic/dschjungelplanet05_v1_magic.webp',
  'varianten/v1_magic/dschjungelplanet06_v1_magic.webp',
  'varianten/v1_magic/dschjungelplanet07_v1_magic.webp',
  'varianten/v1_magic/dschjungelplanet08_v1_magic.webp',
  'varianten/v1_magic/dschjungelplanet09_v1_magic.webp',
  'varianten/v1_magic/dschjungelplanet10_v1_magic.webp',
  'varianten/v1_magic/eisplanet01_v1_magic.webp',
  'varianten/v1_magic/eisplanet02_v1_magic.webp',
  'varianten/v1_magic/eisplanet03_v1_magic.webp',
  'varianten/v1_magic/eisplanet04_v1_magic.webp',
  'varianten/v1_magic/eisplanet05_v1_magic.webp',
  'varianten/v1_magic/eisplanet06_v1_magic.webp',
  'varianten/v1_magic/eisplanet07_v1_magic.webp',
  'varianten/v1_magic/eisplanet08_v1_magic.webp',
  'varianten/v1_magic/eisplanet09_v1_magic.webp',
  'varianten/v1_magic/eisplanet10_v1_magic.webp',
  'varianten/v1_magic/gasplanet01_v1_magic.webp',
  'varianten/v1_magic/gasplanet02_v1_magic.webp',
  'varianten/v1_magic/gasplanet03_v1_magic.webp',
  'varianten/v1_magic/gasplanet04_v1_magic.webp',
  'varianten/v1_magic/gasplanet05_v1_magic.webp',
  'varianten/v1_magic/gasplanet06_v1_magic.webp',
  'varianten/v1_magic/gasplanet07_v1_magic.webp',
  'varianten/v1_magic/gasplanet08_v1_magic.webp',
  'varianten/v1_magic/normaltempplanet01_v1_magic.webp',
  'varianten/v1_magic/normaltempplanet02_v1_magic.webp',
  'varianten/v1_magic/normaltempplanet03_v1_magic.webp',
  'varianten/v1_magic/normaltempplanet04_v1_magic.webp',
  'varianten/v1_magic/normaltempplanet05_v1_magic.webp',
  'varianten/v1_magic/normaltempplanet06_v1_magic.webp',
  'varianten/v1_magic/normaltempplanet07_v1_magic.webp',
  'varianten/v1_magic/trockenplanet01_v1_magic.webp',
  'varianten/v1_magic/trockenplanet02_v1_magic.webp',
  'varianten/v1_magic/trockenplanet03_v1_magic.webp',
  'varianten/v1_magic/trockenplanet04_v1_magic.webp',
  'varianten/v1_magic/trockenplanet05_v1_magic.webp',
  'varianten/v1_magic/trockenplanet06_v1_magic.webp',
  'varianten/v1_magic/trockenplanet07_v1_magic.webp',
  'varianten/v1_magic/trockenplanet08_v1_magic.webp',
  'varianten/v1_magic/trockenplanet09_v1_magic.webp',
  'varianten/v1_magic/trockenplanet10_v1_magic.webp',
  'varianten/v1_magic/wasserplanet01_v1_magic.webp',
  'varianten/v1_magic/wasserplanet02_v1_magic.webp',
  'varianten/v1_magic/wasserplanet03_v1_magic.webp',
  'varianten/v1_magic/wasserplanet04_v1_magic.webp',
  'varianten/v1_magic/wasserplanet05_v1_magic.webp',
  'varianten/v1_magic/wasserplanet06_v1_magic.webp',
  'varianten/v1_magic/wasserplanet07_v1_magic.webp',
  'varianten/v1_magic/wasserplanet08_v1_magic.webp',
  'varianten/v1_magic/wasserplanet09_v1_magic.webp',
  'varianten/v1_magic/wuestenplanet01_v1_magic.webp',
  'varianten/v1_magic/wuestenplanet02_v1_magic.webp',
  'varianten/v1_magic/wuestenplanet03_v1_magic.webp',
  'varianten/v1_magic/wuestenplanet04_v1_magic.webp',
  'varianten/v2_storm/dschjungelplanet01_v2_storm.webp',
  'varianten/v2_storm/dschjungelplanet02_v2_storm.webp',
  'varianten/v2_storm/dschjungelplanet03_v2_storm.webp',
  'varianten/v2_storm/dschjungelplanet04_v2_storm.webp',
  'varianten/v2_storm/dschjungelplanet05_v2_storm.webp',
  'varianten/v2_storm/dschjungelplanet06_v2_storm.webp',
  'varianten/v2_storm/dschjungelplanet07_v2_storm.webp',
  'varianten/v2_storm/dschjungelplanet08_v2_storm.webp',
  'varianten/v2_storm/dschjungelplanet09_v2_storm.webp',
  'varianten/v2_storm/dschjungelplanet10_v2_storm.webp',
  'varianten/v2_storm/eisplanet01_v2_storm.webp',
  'varianten/v2_storm/eisplanet02_v2_storm.webp',
  'varianten/v2_storm/eisplanet03_v2_storm.webp',
  'varianten/v2_storm/eisplanet04_v2_storm.webp',
  'varianten/v2_storm/eisplanet05_v2_storm.webp',
  'varianten/v2_storm/eisplanet06_v2_storm.webp',
  'varianten/v2_storm/eisplanet07_v2_storm.webp',
  'varianten/v2_storm/eisplanet08_v2_storm.webp',
  'varianten/v2_storm/eisplanet09_v2_storm.webp',
  'varianten/v2_storm/eisplanet10_v2_storm.webp',
  'varianten/v2_storm/gasplanet01_v2_storm.webp',
  'varianten/v2_storm/gasplanet02_v2_storm.webp',
  'varianten/v2_storm/gasplanet03_v2_storm.webp',
  'varianten/v2_storm/gasplanet04_v2_storm.webp',
  'varianten/v2_storm/gasplanet05_v2_storm.webp',
  'varianten/v2_storm/gasplanet06_v2_storm.webp',
  'varianten/v2_storm/gasplanet07_v2_storm.webp',
  'varianten/v2_storm/gasplanet08_v2_storm.webp',
  'varianten/v2_storm/normaltempplanet01_v2_storm.webp',
  'varianten/v2_storm/normaltempplanet02_v2_storm.webp',
  'varianten/v2_storm/normaltempplanet03_v2_storm.webp',
  'varianten/v2_storm/normaltempplanet04_v2_storm.webp',
  'varianten/v2_storm/normaltempplanet05_v2_storm.webp',
  'varianten/v2_storm/normaltempplanet06_v2_storm.webp',
  'varianten/v2_storm/normaltempplanet07_v2_storm.webp',
  'varianten/v2_storm/trockenplanet01_v2_storm.webp',
  'varianten/v2_storm/trockenplanet02_v2_storm.webp',
  'varianten/v2_storm/trockenplanet03_v2_storm.webp',
  'varianten/v2_storm/trockenplanet04_v2_storm.webp',
  'varianten/v2_storm/trockenplanet05_v2_storm.webp',
  'varianten/v2_storm/trockenplanet06_v2_storm.webp',
  'varianten/v2_storm/trockenplanet07_v2_storm.webp',
  'varianten/v2_storm/trockenplanet08_v2_storm.webp',
  'varianten/v2_storm/trockenplanet09_v2_storm.webp',
  'varianten/v2_storm/trockenplanet10_v2_storm.webp',
  'varianten/v2_storm/wasserplanet01_v2_storm.webp',
  'varianten/v2_storm/wasserplanet02_v2_storm.webp',
  'varianten/v2_storm/wasserplanet03_v2_storm.webp',
  'varianten/v2_storm/wasserplanet04_v2_storm.webp',
  'varianten/v2_storm/wasserplanet05_v2_storm.webp',
  'varianten/v2_storm/wasserplanet06_v2_storm.webp',
  'varianten/v2_storm/wasserplanet07_v2_storm.webp',
  'varianten/v2_storm/wasserplanet08_v2_storm.webp',
  'varianten/v2_storm/wasserplanet09_v2_storm.webp',
  'varianten/v2_storm/wuestenplanet01_v2_storm.webp',
  'varianten/v2_storm/wuestenplanet02_v2_storm.webp',
  'varianten/v2_storm/wuestenplanet03_v2_storm.webp',
  'varianten/v2_storm/wuestenplanet04_v2_storm.webp',
  'varianten/v3_voronoi/dschjungelplanet01_v3_voronoi.webp',
  'varianten/v3_voronoi/dschjungelplanet02_v3_voronoi.webp',
  'varianten/v3_voronoi/dschjungelplanet03_v3_voronoi.webp',
  'varianten/v3_voronoi/dschjungelplanet04_v3_voronoi.webp',
  'varianten/v3_voronoi/dschjungelplanet05_v3_voronoi.webp',
  'varianten/v3_voronoi/dschjungelplanet06_v3_voronoi.webp',
  'varianten/v3_voronoi/dschjungelplanet07_v3_voronoi.webp',
  'varianten/v3_voronoi/dschjungelplanet08_v3_voronoi.webp',
  'varianten/v3_voronoi/dschjungelplanet09_v3_voronoi.webp',
  'varianten/v3_voronoi/dschjungelplanet10_v3_voronoi.webp',
  'varianten/v3_voronoi/eisplanet01_v3_voronoi.webp',
  'varianten/v3_voronoi/eisplanet02_v3_voronoi.webp',
  'varianten/v3_voronoi/eisplanet03_v3_voronoi.webp',
  'varianten/v3_voronoi/eisplanet04_v3_voronoi.webp',
  'varianten/v3_voronoi/eisplanet05_v3_voronoi.webp',
  'varianten/v3_voronoi/eisplanet06_v3_voronoi.webp',
  'varianten/v3_voronoi/eisplanet07_v3_voronoi.webp',
  'varianten/v3_voronoi/eisplanet08_v3_voronoi.webp',
  'varianten/v3_voronoi/eisplanet09_v3_voronoi.webp',
  'varianten/v3_voronoi/eisplanet10_v3_voronoi.webp',
  'varianten/v3_voronoi/gasplanet01_v3_voronoi.webp',
  'varianten/v3_voronoi/gasplanet02_v3_voronoi.webp',
  'varianten/v3_voronoi/gasplanet03_v3_voronoi.webp',
  'varianten/v3_voronoi/gasplanet04_v3_voronoi.webp',
  'varianten/v3_voronoi/gasplanet05_v3_voronoi.webp',
  'varianten/v3_voronoi/gasplanet06_v3_voronoi.webp',
  'varianten/v3_voronoi/gasplanet07_v3_voronoi.webp',
  'varianten/v3_voronoi/gasplanet08_v3_voronoi.webp',
  'varianten/v3_voronoi/normaltempplanet01_v3_voronoi.webp',
  'varianten/v3_voronoi/normaltempplanet02_v3_voronoi.webp',
  'varianten/v3_voronoi/normaltempplanet03_v3_voronoi.webp',
  'varianten/v3_voronoi/normaltempplanet04_v3_voronoi.webp',
  'varianten/v3_voronoi/normaltempplanet05_v3_voronoi.webp',
  'varianten/v3_voronoi/normaltempplanet06_v3_voronoi.webp',
  'varianten/v3_voronoi/normaltempplanet07_v3_voronoi.webp',
  'varianten/v3_voronoi/trockenplanet01_v3_voronoi.webp',
  'varianten/v3_voronoi/trockenplanet02_v3_voronoi.webp',
  'varianten/v3_voronoi/trockenplanet03_v3_voronoi.webp',
  'varianten/v3_voronoi/trockenplanet04_v3_voronoi.webp',
  'varianten/v3_voronoi/trockenplanet05_v3_voronoi.webp',
  'varianten/v3_voronoi/trockenplanet06_v3_voronoi.webp',
  'varianten/v3_voronoi/trockenplanet07_v3_voronoi.webp',
  'varianten/v3_voronoi/trockenplanet08_v3_voronoi.webp',
  'varianten/v3_voronoi/trockenplanet09_v3_voronoi.webp',
  'varianten/v3_voronoi/trockenplanet10_v3_voronoi.webp',
  'varianten/v3_voronoi/wasserplanet01_v3_voronoi.webp',
  'varianten/v3_voronoi/wasserplanet02_v3_voronoi.webp',
  'varianten/v3_voronoi/wasserplanet03_v3_voronoi.webp',
  'varianten/v3_voronoi/wasserplanet04_v3_voronoi.webp',
  'varianten/v3_voronoi/wasserplanet05_v3_voronoi.webp',
  'varianten/v3_voronoi/wasserplanet06_v3_voronoi.webp',
  'varianten/v3_voronoi/wasserplanet07_v3_voronoi.webp',
  'varianten/v3_voronoi/wasserplanet08_v3_voronoi.webp',
  'varianten/v3_voronoi/wasserplanet09_v3_voronoi.webp',
  'varianten/v3_voronoi/wuestenplanet01_v3_voronoi.webp',
  'varianten/v3_voronoi/wuestenplanet02_v3_voronoi.webp',
  'varianten/v3_voronoi/wuestenplanet03_v3_voronoi.webp',
  'varianten/v3_voronoi/wuestenplanet04_v3_voronoi.webp',
];

// Get a random planet name with weighted probability:
// 90% chance for regular planets, 10% chance for variant planets
export const getRandomPlanetName = () => {
  // 10% chance (0.0 to 0.1) to select from variants
  const useVariant = Math.random() < 0.1;
  
  if (useVariant) {
    const randomIndex = Math.floor(Math.random() * variantPlanetNames.length);
    return variantPlanetNames[randomIndex];
  } else {
    const randomIndex = Math.floor(Math.random() * regularPlanetNames.length);
    return regularPlanetNames[randomIndex];
  }
};

